import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const DeleteIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        d="M27,10V28a3,3,0,0,1-3,3H8a3,3,0,0,1-3-3V10"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        x1={16}
        y1={15}
        x2={16}
        y2={25}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        x1={11}
        y1={15}
        x2={11}
        y2={25}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        x1={21}
        y1={15}
        x2={21}
        y2={25}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <polyline
        data-cap="butt"
        data-color="color-2"
        points="11 6 11 1 21 1 21 6"
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        data-color="color-2"
        x1={30}
        y1={6}
        x2={2}
        y2={6}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
    </svg>
  );
};
